import Table from './components/Table';
import Graph from './components/Graph';
import './App.css';




function App() {
  return (
    <div style={{
      padding: '2rem',
    }}>
      <h1 style={{
        textAlign: 'center',
        color: '#2d3748',
        fontSize: '2.5rem',
        textShadow: '1px 1px 2px rgba(0, 0, 0, 0.28)',
        paddingBottom: '1rem',
      }}>
        Currency Dashboard
      </h1>
      <Graph />
      <br />
      <Table />
    </div>
  );
}


export default App;
